(function(){
  var cache=null, loading=null;
  function load(src){ if(cache) return Promise.resolve(cache); if(loading) return loading;
    loading=fetch(src).then(function(r){return r.json()}).then(function(d){
      cache=d.map(function(x){return {m:x[0],b:x[1],t:x[2],s:x[3],k:(x[0]+' '+x[1]).toUpperCase().replace(/[^A-Z0-9 ]/g,''),km:x[0].toUpperCase().replace(/[^A-Z0-9]/g,'')}}); return cache;});
    return loading; }
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function init(root){
    var dlg=root.querySelector('.ms-dialog'); if(!dlg) return;
    var input=dlg.querySelector('.ms-input'), list=dlg.querySelector('.ms-results'), meta=dlg.querySelector('.ms-meta'), empty=dlg.querySelector('.ms-empty');
    var src=dlg.getAttribute('data-src'), base=dlg.getAttribute('data-base')||'/pages/';
    function render(q){
      load(src).then(function(data){
        var toks=q.toUpperCase().replace(/[^A-Z0-9 ]/g,' ').split(/\s+/).filter(Boolean);
        if(!toks.length){ list.innerHTML=''; meta.textContent='Type a brand or remote model number. These are examples, not a complete list.'; empty.hidden=true; return; }
        var hits=[];
        for(var i=0;i<data.length;i++){ var d=data[i], ok=true;
          for(var j=0;j<toks.length;j++){ var t=toks[j]; if(d.k.indexOf(t)<0 && d.km.indexOf(t)<0){ok=false;break} }
          if(ok) hits.push(d); }
        var shown=hits.slice(0,80);
        list.innerHTML=shown.map(function(d){
          var guide=d.s?'<a class="ms-guide" href="'+esc(base+d.s+'-mini-splits')+'">'+esc(d.b)+' guide ›</a>':'';
          return '<li><span class="ms-model">'+esc(d.m)+'</span><span class="ms-sub">'+'Remote · '+esc(d.b)+'</span>'+guide+'</li>'; }).join('');
        meta.textContent=hits.length? (hits.length>shown.length? 'Showing '+shown.length+' of '+hits.length.toLocaleString()+' matches. Keep typing to narrow it down.' : hits.length+' match'+(hits.length===1?'':'es')+'.') : '';
        empty.hidden=hits.length>0;
      }).catch(function(){ meta.textContent='The model list could not load. Please try again.'; });
    }
    var timer; input.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(function(){render(input.value)},120)});
    root.querySelectorAll('[data-ms-open]').forEach(function(btn){ btn.addEventListener('click',function(){
      input.value=btn.getAttribute('data-ms-open')||''; if(dlg.showModal) dlg.showModal(); else dlg.setAttribute('open','');
      render(input.value); setTimeout(function(){input.focus(); input.setSelectionRange(input.value.length,input.value.length)},30); }); });
    dlg.querySelector('.ms-close').addEventListener('click',function(){dlg.close?dlg.close():dlg.removeAttribute('open')});
    dlg.addEventListener('click',function(e){ if(e.target===dlg){ dlg.close(); } });
  }
  function boot(){ document.querySelectorAll('.msc').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
